import { Component } from '@verndale/core';
import Cookies from 'js-cookie';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $mainPage: document.querySelector('.community-landing-page-coveo')
    };
    this.ssl_latitude = this.dom.$mainPage.dataset.sslLatitude;
    this.ssl_longitude = this.dom.$mainPage.dataset.sslLongitude;
    this.ssl_communityname = this.dom.$mainPage.dataset.sslCommunityname;
    this.ssl_thumbnailimage = this.dom.$mainPage.dataset.sslThumbnailimage;
    this.ssl_mainimagedesktop = this.dom.$mainPage.dataset.sslMainimagedesktop;
    this.ssl_pricingandavailabilityphone = this.dom.$mainPage.dataset.sslPricingandavailabilityphone;
    this.ssl_residentsandfamilyphone = this.dom.$mainPage.dataset.sslResidentsandfamilyphone;
    this.ssl_contextlanguage = this.dom.$mainPage.dataset.sslContextlanguage;
    this.ssl_communityid = this.dom.$mainPage.dataset.sslCommunityid;

    this.communityUrl = this.getCommunityLink();

    if (this.ssl_communityid){
      this.recentCommunites = []

      this.currentCommunity = {
        ssl_latitude: this.ssl_latitude,
        ssl_longitude: this.ssl_longitude,
        ssl_communityname: this.ssl_communityname,
        ssl_thumbnailimage: this.ssl_thumbnailimage ? this.ssl_thumbnailimage : this.ssl_mainimagedesktop,
        ssl_pricingandavailabilityphone: this.ssl_pricingandavailabilityphone,
        ssl_residentsandfamilyphone: this.ssl_residentsandfamilyphone,
        ssl_contextlanguage: this.ssl_contextlanguage,
        ssl_communityid: this.ssl_communityid,
        ssl_communitylink: this.communityUrl
      }

      this.handleCommunityData();

      if (Cookies.get('recent_communities')){
        this.recentlyViewedCommunities = JSON.parse(Cookies.get('recent_communities'));
      }
    }

    this.location = Cookies.get('ssl-location');

    if (this.location){
      this.userLocation = JSON.parse(this.location);
    }
  }

  getCommunityLink() {
    const { hostname, pathname } = window.location;
    if (window.location.pathname.includes('/thank-you')) {
      return `https://${hostname}${pathname.replace('/thank-you', '')}`;
    }

    return `https://${hostname}${pathname}`;
  }

  handleCommunityData() {
    this.storeCommunity();
    this.storeRecentCommunites();
  }

  storeRecentCommunites(){
    if (!Cookies.get('recent_communities')){
      this.recentCommunites.push(this.currentCommunity);
      const recentCommunitiesString = JSON.stringify(this.recentCommunites);
      Cookies.set('recent_communities', recentCommunitiesString);
    } else {
      const recentCommunitiesValue = JSON.parse(Cookies.get('recent_communities'));
      const communityId = recentCommunitiesValue.findIndex(object => object.ssl_communityid === this.currentCommunity.ssl_communityid);
      if (communityId === -1 && recentCommunitiesValue.length < 5){
        recentCommunitiesValue.push(this.currentCommunity);
      } else if (communityId === -1){
        recentCommunitiesValue.splice(0, 1);
        recentCommunitiesValue.push(this.currentCommunity);
      } else {
        const elementIndex = communityId;
        const elementObj = recentCommunitiesValue.splice(elementIndex, 1)[0]
        recentCommunitiesValue.splice(recentCommunitiesValue.length, 0, elementObj);
      }
      const recentCommunitiesValueString = JSON.stringify(recentCommunitiesValue);
      Cookies.set('recent_communities', recentCommunitiesValueString);
    }
  }

  storeCommunity(){
    const currentCommunityString = JSON.stringify(this.currentCommunity);
    Cookies.set('current_community', currentCommunityString);
    this.renderCommunity();
    this.recentCommunitiesHandler();
  }

  renderCommunity(){
    if (this.currentCommunity.ssl_communityid){
      const { ssl_communityname, ssl_thumbnailimage, ssl_pricingandavailabilityphone, ssl_residentsandfamilyphone, ssl_distance, ssl_communitylink } = this.currentCommunity;
      if (ssl_communityname && ssl_communitylink){
        const communityHeader = document.querySelector('.schedule-a-tour-current-community__card-name');
        const communityImage = document.querySelector('.schedule-a-tour-current-community__image');
        const availabilityPhone = document.querySelector('.schedule-a-tour__availability-contact a');
        const residentsPhone = document.querySelector('.schedule-a-tour__residents-contact a');
        const communityLink = document.querySelector('.schedule-a-tour-current-community__card');

        if (communityLink){
          communityLink.href = ssl_communitylink;
          communityLink.alt = ssl_communityname;
        }

        if (communityHeader) communityHeader.textContent = ssl_communityname;
        if (communityImage) communityImage.src = ssl_thumbnailimage;
        if (availabilityPhone) {
          availabilityPhone.querySelector('.btn__label').textContent = ssl_pricingandavailabilityphone;
          availabilityPhone.href = `tel:${ssl_pricingandavailabilityphone}`;
        }
        if (residentsPhone) {
          residentsPhone.querySelector('.btn__label').textContent = ssl_residentsandfamilyphone;
          residentsPhone.href = `tel:${ssl_residentsandfamilyphone}`;
        }
      }

      if (ssl_distance){
        const communityDistance = document.querySelector('.schedule-a-tour-current-community__card-distance');
        if (communityDistance) {
          communityDistance.textContent = `${ssl_distance} ${this.el.dataset.unitLabel}`;
        }
      }
    }
  }

  recentCommunitiesHandler(){
    if (this.recentlyViewedCommunities && this.recentlyViewedCommunities.length > 2){
      const recentCommunitiesWrapper = document.querySelector('.primary-nav__recently-viewed-communities');
      this.recentlyViewedCommunities.reverse();
      this.recentlyViewedCommunities.map(el => {
        if (el.ssl_communityid !== this.currentCommunity.ssl_communityid){
          const communityLink = document.createElement('a');
          communityLink.href = el.ssl_communitylink;
          communityLink.classList.add('primary-nav__recently-viewed-communities-link');
          const communityImage = document.createElement('img');
          communityImage.src = `${el.ssl_thumbnailimage}`;
          communityImage.classList.add('primary-nav__recently-viewed-communities-image');
          const communityInfo = document.createElement('div');
          communityInfo.classList.add('primary-nav__recently-viewed-communities-info');
          const communityTitle = document.createElement('span');
          communityTitle.classList.add('primary-nav__recently-viewed-communities-title');
          communityTitle.textContent = el.ssl_communityname;
          const communityDistance = document.createElement('span');
          communityDistance.classList.add('primary-nav__recently-viewed-communities-distance');
          const unitLabel = this.dom.$panel?.dataset.unitLabel ? this.dom.$panel.dataset.unitLabel : 'miles away';
          communityDistance.textContent = el.ssl_distance ? `${el.ssl_distance} ${unitLabel}` : '';

          communityInfo.append(communityTitle);
          communityInfo.append(communityDistance);
          communityLink.append(communityImage);
          communityLink.append(communityInfo);
          if (recentCommunitiesWrapper){
            recentCommunitiesWrapper.append(communityLink);
          }
        }
      });
    } else {
      const communitiesColumn = document.querySelector('.schedule-a-tour__content');
      if (communitiesColumn){
        const communitiesSibling =  communitiesColumn?.nextElementSibling
        communitiesSibling.remove();
      }
    }
  }
}

export default Module;
